import { useEffect, useState } from "react";
import { ACADEMICTYPE, baseURL } from "../../API/API";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import useAuth from "../hooks/useAuth";

export default function CoursesList({ type }) {
  const [courses, setCourses] = useState([]);
  const [studentAcademicId, setStudentAcademicId] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { auth } = useAuth();

  useEffect(() => {
    if (!auth?.accessToken) return;

    axiosPrivate
      .get(`${baseURL}/${ACADEMICTYPE}/${type}/`)
      .then((res) => {
        setCourses(res.data?.data || []);
        const fromApi = res.data?.studentAcademicId;
        const fromUser = auth?.user?.academic_year_id;
        setStudentAcademicId(fromApi ?? fromUser ?? null);
      })
      .catch((err) => {
        console.error("CoursesList error:", err?.response?.data || err);
        const fallbackId = auth?.user?.academic_year_id;
        if (fallbackId) {
          setStudentAcademicId(fallbackId);
        }
        if (err?.response?.status === 401) {
          toast.error("انتهت الجلسة. سجّل الدخول مرة أخرى.");
        }
      });
  }, [type, axiosPrivate, auth?.accessToken, auth?.user?.academic_year_id]);

  const handleCourseClick = (courseId) => {
    if (auth?.user?.is_staff) {
      navigate(`/learn/${courseId}`);
      return;
    }

    const enrolledId =
      studentAcademicId ?? auth?.user?.academic_year_id ?? null;

    if (!enrolledId) {
      toast.error("تعذر تحديد مرحلتك الدراسية. حدّث الصفحة أو سجّل الدخول مجدداً.");
      console.error("CoursesList: no studentAcademicId", {
        studentAcademicId,
        user: auth?.user,
      });
      return;
    }

    if (Number(courseId) !== Number(enrolledId)) {
      toast.error(
        "أنت لست مسجل في هذه المرحلة، من فضلك توجه إلى المرحلة الدراسية الخاصة بك."
      );
      return;
    }

    navigate(`/learn/${courseId}`);
  };

  return (
    <div className="menu" style={{ backgroundColor: "transparent" }}>
      {courses.length === 0 ? (
        <p className="text-center text-muted p-3">لا توجد مراحل متاحة</p>
      ) : (
        courses.map((course) => {
          const enrolledId =
            studentAcademicId ?? auth?.user?.academic_year_id;
          const isMyCourse =
            auth?.user?.is_staff ||
            Number(course.id) === Number(enrolledId);

          return (
            <div
              key={course.id}
              onClick={() => handleCourseClick(course.id)}
              style={{
                cursor: "pointer",
                textDecoration: "none",
                color: "inherit",
                opacity: isMyCourse ? 1 : 0.85,
              }}
            >
              <div className="contant_menu">
                <FontAwesomeIcon icon={faGraduationCap} /> {course.name}
                {isMyCourse && !auth?.user?.is_staff && (
                  <span className="ms-2 small text-success">(مرحلتك)</span>
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
